export enum DecisionAndApplyStatuses {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Redirect = 'REDIRECT',
}

export type DecisionAndApplyResponse = {
  decision: DecisionAndApplyStatuses;
};
